import React from "react";

/**
 * Clickable for previous steps only.
 * Designed for the new 2-step flow while keeping the older clean search feel.
 */
export default function Stepper({ steps, current = 0, onStepChange }) {
  const progress =
    steps.length > 1 ? (current / (steps.length - 1)) * 100 : 100;

  return (
    <div>
      <div className="flex items-center justify-between text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400">
        <span>Search flow</span>
        <span>
          {String(current + 1).padStart(2, "0")} /{" "}
          {String(steps.length).padStart(2, "0")}
        </span>
      </div>

      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-100">
        <div
          className="h-full rounded-full bg-slate-900 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {steps.map((label, idx) => {
          const done = idx < current;
          const active = idx === current;
          const canClick = idx < current;

          return (
            <button
              key={label}
              type="button"
              onClick={() => canClick && onStepChange && onStepChange(idx)}
              aria-current={active ? "step" : undefined}
              className={[
                "relative rounded-2xl border p-4 sm:py-5 pl-16 text-left shadow-sm transition",
                active
                  ? "border-black bg-black text-white"
                  : done
                  ? "border-slate-300 bg-slate-50 text-slate-900"
                  : "border-slate-200 bg-white text-slate-900",
                canClick ? "cursor-pointer hover:ring-2 hover:ring-black/10" : "cursor-default",
              ].join(" ")}
            >
              <span
                aria-hidden="true"
                className={[
                  "absolute left-4 top-1/2 -translate-y-1/2",
                  "inline-flex items-center justify-center",
                  "w-8 h-8 rounded-full shrink-0 select-none",
                  "text-sm font-semibold leading-none tabular-nums ring-1 ring-black/5",
                  active
                    ? "bg-white text-black"
                    : done
                    ? "bg-slate-900 text-white"
                    : "bg-slate-100 text-slate-600",
                ].join(" ")}
              >
                {done ? "✓" : idx + 1}
              </span>

              <div className="font-medium">{label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}